import { render, staticRenderFns } from "./distributRecord.vue?vue&type=template&id=12588e28&scoped=true&"
import script from "./distributRecord.vue?vue&type=script&lang=js&"
export * from "./distributRecord.vue?vue&type=script&lang=js&"
import style0 from "./distributRecord.vue?vue&type=style&index=0&id=12588e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12588e28",
  null
  
)

export default component.exports